import {  useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDebounce } from '@scramble/hooks';
import { LOAN_GROUPS_IDS } from '@/helpers/constants';
import { useGetGrowthCalculatorResult } from '@/query/queries/calculator/useGetGrowthCalculatorResult';

export const FormObserver = ({ setResult }) => {
  const { values } = useFormikContext();
  const debouncedValues = useDebounce(values, 500);
  const { data, isLoading, isError } = useGetGrowthCalculatorResult(
    {
      initial: debouncedValues.initial,
      monthly_investment: debouncedValues.monthly_investment,
      term: debouncedValues.term,
      group_id: debouncedValues.group_id,
      is_bonuses_included:
        debouncedValues.group_id === LOAN_GROUPS_IDS.conservative.id
          ? debouncedValues.is_bonuses_included
          : false
    },
    !!debouncedValues,
  );

  useEffect(() => {
    setResult({ isLoading, isError, data });
  }, [data, isLoading]);

  return null;
};
